import axios from 'axios'

export default function init() {}

export async function getNotificationLogs(app,apiHost,paginationPayload = '') {
  const protocol = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  const url = `${protocol}${apiHost}/v3/notifications/v1/logs?limit=10${ paginationPayload ? "&" : ""}${paginationPayload}`

  const ccBearerToken = localStorage.getItem('ccBearerToken')
  try {
    if (ccBearerToken) {
      const response = await axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: `Bearer ${ccBearerToken}`,
          apiKey: app.accessKey,
        },
      })
      return response.data
    }
  } catch (error) {
    return error.response?.data || { error: 'Failed to fetch notification logs' }
  }
  return false
}